/*
 * Countdown module.
 *
 * Ticks down to the reveal date held in data-reveal-date, then swaps the module
 * over to its reveal state and fires the confetti burst. When the page is
 * loaded after the date has already passed the markup ships pre-revealed, so
 * here we only need to fire the confetti.
 */
import { launchConfetti } from "./confetti";

const UNIT_MS = {
    d: 1000 * 60 * 60 * 24,
    h: 1000 * 60 * 60,
    m: 1000 * 60,
    s: 1000,
};

// Just enough delay for the section to paint before the burst starts.
const LOAD_BURST_DELAY = 120;

const pad = (value) => String(Math.max(0, value)).padStart(2, "0");

const splitDistance = (distance) => ({
    d: Math.floor(distance / UNIT_MS.d),
    h: Math.floor((distance % UNIT_MS.d) / UNIT_MS.h),
    m: Math.floor((distance % UNIT_MS.h) / UNIT_MS.m),
    s: Math.floor((distance % UNIT_MS.m) / UNIT_MS.s),
});

const setup = (module) => {
    const target = Date.parse(module.dataset.revealDate || "");
    if (Number.isNaN(target)) return;

    const values = module.querySelectorAll(".countdown__value");
    let revealed = module.classList.contains("countdown--revealed");
    let interval = null;

    const reveal = () => {
        if (revealed) return;
        revealed = true;
        if (interval !== null) clearInterval(interval);
        module.classList.add("countdown--revealed");
        launchConfetti();
    };

    const render = () => {
        const distance = target - Date.now();

        if (distance <= 0) {
            reveal();
            return;
        }

        const time = splitDistance(distance);
        values.forEach((value) => {
            const key = value.dataset.unit;
            if (key in time) value.textContent = pad(time[key]);
        });
    };

    if (revealed) {
        // Already past the date on page load — just celebrate.
        window.setTimeout(launchConfetti, LOAD_BURST_DELAY);
        return;
    }

    render();
    interval = window.setInterval(render, 1000);
};

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".countdown").forEach(setup);
});
